import {
  COLLAPSE_HEADER,
  EXPAND_HEADER,
  TOGGLE_HEADER,
  SET_COLLAPSING,
  SET_STICKY,
  TOGGLE_MORE_INFO,
  TOGGLE_RELATED_PROJECTS,
  TOGGLE_RELATED_PROJECTS_SHOW_ALL
} from './constants'

const collapseHeader = () => ({ type: COLLAPSE_HEADER })
const expandHeader = () => ({ type: EXPAND_HEADER })
const toggleHeader = () => ({ type: TOGGLE_HEADER })

const setCollapsing = (collapsing) => ({ type: SET_COLLAPSING, collapsing })

const setSticky = (sticky) => ({ type: SET_STICKY, sticky }) 

const toggleMoreInfo = () => ({ type: TOGGLE_MORE_INFO })

const toggleRelatedProjects = () => ({ type: TOGGLE_RELATED_PROJECTS })

const toggleRelatedProjectsShowAll = () => ({ type: TOGGLE_RELATED_PROJECTS_SHOW_ALL })

export {
  collapseHeader,
  expandHeader,
  toggleHeader,
  setCollapsing,
  setSticky,
  toggleMoreInfo,
  toggleRelatedProjects,
  toggleRelatedProjectsShowAll
}
